// モーダル表示
import commonClass from "./commonClass";

export default class modalClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._mdl_trg = '.js-modal';
    this._mdl_close = '.js-modal-close';
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;

    // モーダル表示
    $(document).on('click', cls._mdl_trg, function() {
      closeLoader('common_loader');
      cls._open($(this));
    });

    // モーダル非表示
    $(document).on('click', cls._mdl_close, function() {
      cls._close($(this));
    });
  }

  _open($trg) {
    var cls = this;
    var $window = $(window);
    var $body = $('body');

    var modalName = $trg.data('mdname');
    // 共通confirm
    if (modalName == 'common_confirm') {
      $('.c-modal_guide').html($trg.data('guide'));
      $('.c-modal_lead').html($trg.data('lead'));
      $('.c-btn_submit').attr('form', $trg.data('form'));
      $('.c-btn_submit').attr('formaction', $trg.data('formaction'));
    }
    $('[data-mdtrg = "' + modalName + '"]').fadeIn();

    // DataTablesの初期化のため、モーダル展開時にリサイズを走らせています
    $window.resize();
    $body.addClass('isShowhowModal');
  }

  _close($trg) {
    var cls = this;
    var $window = $(window);
    var $body = $('body');

    $trg.parents('.c-modal').fadeOut();

    $body.removeClass('isShowhowModal');
  }

}